import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mcp-carousel__header" }
const _hoisted_2 = {
  key: 0,
  class: "mcp-carousel__controls",
  role: "group",
  "aria-label": "Carousel navigation"
}
const _hoisted_3 = {
  key: 0,
  class: "mcp-carousel__empty text-body-2 text-medium-emphasis"
}
const _hoisted_4 = {
  key: 1,
  class: "mcp-carousel__track-frame"
}
const _hoisted_5 = {
  key: 2,
  class: "mcp-carousel__footer"
}
const _hoisted_6 = {
  key: 0,
  class: "mcp-carousel__dots",
  role: "tablist",
  "aria-label": "Carousel pages"
}
const _hoisted_7 = ["aria-label", "aria-selected", "onClick"]
const _hoisted_8 = { class: "mcp-carousel__meta text-body-2 text-medium-emphasis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_McpServerCarouselCard = _resolveComponent("McpServerCarouselCard")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mcp-carousel",
    variant: "outlined",
    onMouseenter: _ctx.handleMouseEnter,
    onMouseleave: _ctx.handleMouseLeave,
    onFocusin: _ctx.handleFocusIn,
    onFocusout: _ctx.handleFocusOut
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, { class: "mcp-carousel__content" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mcp-carousel__copy" }, [
              _createElementVNode("div", { class: "mcp-carousel__eyebrow" }, "MCP HUB · DISCOVER"),
              _createElementVNode("h2", { class: "mcp-carousel__title" }, "Plug your squad into the world"),
              _createElementVNode("p", { class: "mcp-carousel__subtitle" }, " Install new servers, reconnect OAuth, or jump straight into tools from the MCP servers already available in your workspace. ")
            ], -1)),
            (_ctx.totalPages > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    onClick: _ctx.goToPreviousPage,
                    "aria-label": "Previous MCP servers"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode("mdi-chevron-left")
                        ])),
                        _: 1,
                        __: [1]
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    onClick: _ctx.goToNextPage,
                    "aria-label": "Next MCP servers"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-chevron-right")
                        ])),
                        _: 1,
                        __: [2]
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.carouselItems.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " No MCP servers are available yet. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[4] || (_cache[4] = _createElementVNode("div", {
                  class: "mcp-carousel__edge mcp-carousel__edge--left",
                  "aria-hidden": "true"
                }, null, -1)),
                _createElementVNode("div", {
                  ref: "track",
                  class: "mcp-carousel__track",
                  style: _normalizeStyle(_ctx.trackStyle),
                  onPointerdown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePointerInteraction && _ctx.handlePointerInteraction(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselItems, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.serverName,
                      class: "mcp-carousel__track-card"
                    }, [
                      _createVNode(_component_McpServerCarouselCard, {
                        item: item,
                        onPrimaryAction: _ctx.handlePrimaryAction
                      }, null, 8, ["item", "onPrimaryAction"])
                    ]))
                  }), 128))
                ], 36),
                _cache[5] || (_cache[5] = _createElementVNode("div", {
                  class: "mcp-carousel__edge mcp-carousel__edge--right",
                  "aria-hidden": "true"
                }, null, -1))
              ])),
          (_ctx.carouselItems.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.totalPages > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (pageIndex) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: `carousel-page-${pageIndex}`,
                          class: _normalizeClass(['mcp-carousel__dot', { 'mcp-carousel__dot--active': pageIndex === _ctx.page }]),
                          "aria-label": `Go to page ${pageIndex + 1} of ${_ctx.totalPages}`,
                          "aria-selected": pageIndex === _ctx.page,
                          role: "tab",
                          type: "button",
                          onClick: ($event: any) => (_ctx.goToPage(pageIndex))
                        }, null, 10, _hoisted_7))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.footerMeta), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onMouseenter", "onMouseleave", "onFocusin", "onFocusout"]))
}